import {Form, FormInstance} from 'antd';
import DatePicker, {DateObject} from 'react-multi-date-picker';
import TimePicker from 'react-multi-date-picker/plugins/time_picker';
import {Rule} from 'antd/es/form';
import {FormatDateEnum} from '@/models';
import {CalendarSvg, ClockSvg} from '../Icons';
import styles from './index.module.scss';

export interface IDatePickerCompProps {
  label: string;
  name: string;
  form: FormInstance<any>;
  placeholder?: string;
  format?: FormatDateEnum;
  rules?: Rule[];
  handleChange?: (value: Date) => void;
  isTimePicker?: boolean;
  className?: string;
  disabled?: boolean;
}

const TimePickerComp = ({
                          label,
                          name,
                          form,
                          format = FormatDateEnum.YMD,
                          rules = [],
                          handleChange,
                          isTimePicker = false,
                          placeholder,
                          className,
                          disabled = false,
                        }: IDatePickerCompProps) => {
  const value = Form.useWatch(name, form);

  return (
    <Form.Item
      rules={rules}
      label={label}
      name={name}
      validateTrigger='onChange'
      className={`${styles.datePicker} ${className || ''}`}
    >
      <DatePicker
        value={value}
        onChange={val => {
          if (val instanceof DateObject) {
            const dateValue = val.toDate();
            form.setFieldsValue({[name]: dateValue});
            form.validateFields([name]);
            if (handleChange) {
              handleChange(dateValue);
            }
          }
        }}
        disabled={disabled}
        placeholder={placeholder}
        format={format}
        // hideOnScroll
        disableDayPicker={!!isTimePicker}
        editable={false}
        plugins={isTimePicker ? [<TimePicker hideSeconds/>] : []}
      />
      <span className={styles.calendarIcon}>
        {isTimePicker ? <ClockSvg/> : <CalendarSvg/>}
      </span>
    </Form.Item>
  );
};

export default TimePickerComp;
